<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
  <app-wellcome />
  <div
    id="register-form-wrapper"
    fusePerfectScrollbar
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <div id="register-form">
      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/fuse.svg" />
      </div>
      <form
        name="registerForm"
        autocomplete="off"
        *ngIf="registerForm"
        [formGroup]="registerForm"
        (submit)="onSubmit()"
        class="mat-flex"
        novalidate
      >
        <div *ngIf="step === regiStep.createAccount">
          <div class="title">CREAR CUENTA</div>
          <mat-form-field appearance="outline">
            <mat-label id="country">Pais</mat-label>
            <mat-select
              #paisSelect
              (selectionChange)="validPais()"
              formControlName="paisesId"
              required
            >
              <div>
                <ngx-mat-select-search
                  formControlName="paisesFilter"
                  (input)="buscarPais($event)"
                  ariaLabel="Buscar país"
                />
              </div>
              <mat-option
                [value]="pais.id"
                *ngFor="let pais of paisesFiltrados"
              >
                {{ pais.name }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="registerForm.get('paisesId')!.hasError('required')"
            >
              Pais es requerido
            </mat-error>
            <mat-error
              *ngIf="registerForm.get('paisesId')!.hasError('notPais')"
            >
              Solo se puede hacer un registro para el pais de ECUADOR
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="step === regiStep.registerUser">
          <div class="title">REGISTRO USUARIO</div>
          <mat-form-field id="card-id" appearance="outline">
            <mat-label>Cedula</mat-label>
            <input
              numbersOnly
              matInput
              (blur)="checkCedula()"
              autocomplete="cedula"
              formControlName="cedula"
              maxlength="10"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getCedulaErrorTooltip()"
              [ngClass]="{ 'error-icon': hasCedulaError() }"
              >featured_play_list</mat-icon
            >
          </mat-form-field>
          <mat-label
            *ngIf="
              !registerForm.get('cedula')!.hasError('prospectoExiste') &&
              !registerForm.get('cedula')!.hasError('cedulaExiste')
            "
          >
            <app-date-picker
              [label]="'Fecha Expiración Cedula*'"
              (dateChange)="selectFecha($event)"
              [minDate]="minDateCarIdExpiration"
            ></app-date-picker>
          </mat-label>
          <mat-form-field
            id="first-name"
            appearance="outline"
            *ngIf="
              !registerForm.get('cedula')!.hasError('prospectoExiste') &&
              !registerForm.get('cedula')!.hasError('cedulaExiste')
            "
          >
            <mat-label>Nombres</mat-label>
            <input
              matInput
              toUpperCase
              autocomplete="nombres"
              (blur)="checkNombreCompleto()"
              formControlName="firstName"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getNombreErrorTooltip()"
              [ngClass]="{ 'error-icon': hasNombreError() }"
              >account_circle</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            id="last-name"
            appearance="outline"
            *ngIf="
              !registerForm.get('cedula')!.hasError('prospectoExiste') &&
              !registerForm.get('cedula')!.hasError('cedulaExiste')
            "
          >
            <mat-label>Apellidos</mat-label>
            <input
              matInput
              toUpperCase
              autocomplete="apellidos"
              (blur)="checkNombreCompleto()"
              formControlName="lastName"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getApellidoErrorTooltip()"
              [ngClass]="{ 'error-icon': hasApellidoError() }"
              >account_circle</mat-icon
            >
          </mat-form-field>
          <mat-form-field
            id="phone"
            appearance="outline"
            class="no-padding-prefix"
            (click)="showCVSCountry = true"
            (blur)="showCVSCountry = false"
            *ngIf="
              !registerForm.get('cedula')!.hasError('prospectoExiste') &&
              !registerForm.get('cedula')!.hasError('cedulaExiste')
            "
          >
            <mat-label>Celular</mat-label>
            <input
              numbersOnly
              matInput
              autocomplete="celular"
              (blur)="checkCelular()"
              (blur)="showCVSCountry = false"
              formControlName="celular"
              maxlength="10"
              required
            />
            <span
              *ngIf="showCVSCountry || registerForm.get('celular')!.value"
              matPrefix
              class="matprefix-text"
            >
              +{{ paisSeleccionado.phoneCode }}</span
            >
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getCelErrorTooltip()"
              [ngClass]="{ 'error-icon': hasCelError() }"
              >contact_phone</mat-icon
            >
          </mat-form-field>
          <mat-label
            id="gender"
            *ngIf="
              !registerForm.get('cedula')!.hasError('prospectoExiste') &&
              !registerForm.get('cedula')!.hasError('cedulaExiste')
            "
          >
            <mat-form-field appearance="outline">
              <mat-label>Género</mat-label>
              <mat-select formControlName="genero" required>
                <mat-option value="FEMENINO">Femenino</mat-option>
                <mat-option value="MASCULINO">Masculino</mat-option>
                <mat-option value="OTROS">Otros</mat-option>
              </mat-select>
              <mat-icon
                matSuffix
                class="secondary-text"
                [matTooltip]="getGeneroErrorTooltip()"
                [ngClass]="{ 'error-icon': hasGeneroError() }"
                >accessibility_new</mat-icon
              >
            </mat-form-field>
          </mat-label>
        </div>
        <div *ngIf="step === regiStep.securityFilter">
          <div class="title">
            FILTRO SEGURIDAD
            <mat-icon
              matSuffix
              matTooltip="Evita que terceros se apropien de tu cuenta"
              style="font-size: 16px; color: grey"
              onmouseover="this.style.color='darkcyan'"
              onmouseout="this.style.color='gray'"
              >info</mat-icon
            >
          </div>
          <mat-form-field appearance="outline">
            <mat-label>Color</mat-label>
            <mat-select autocomplete="color" formControlName="color" required>
              <mat-option [value]="color.value" *ngFor="let color of colores">{{
                color.text
              }}</mat-option>
            </mat-select>
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getColorErrorTooltip()"
              [ngClass]="{ 'error-icon': hasColorError() }"
              >security</mat-icon
            >
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Mascota</mat-label>
            <mat-select
              autocomplete="mascota"
              formControlName="mascota"
              required
            >
              <mat-option
                [value]="mascota.value"
                *ngFor="let mascota of mascotas"
                >{{ mascota.text }}</mat-option
              >
            </mat-select>
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getMascotaErrorTooltip()"
              [ngClass]="{ 'error-icon': hasMascotaError() }"
              >security</mat-icon
            >
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fruta</mat-label>
            <mat-select autocomplete="fruta" formControlName="fruta" required>
              <mat-option [value]="fruta.value" *ngFor="let fruta of frutas">{{
                fruta.text
              }}</mat-option>
            </mat-select>
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getFrutaErrorTooltip()"
              [ngClass]="{ 'error-icon': hasFrutaError() }"
              >security</mat-icon
            >
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              autocomplete="email"
              (blur)="checkEmail()"
              formControlName="email"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getEmailErrorTooltip()"
              [ngClass]="{ 'error-icon': hasEmailError() }"
              >mail</mat-icon
            >
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Contraseña</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="none"
              maxlength="16"
              formControlName="password"
            />
            <button
              (click)="checkPassword()"
              matSuffix
              mat-icon-button
              aria-label="mostrar"
              type="button"
              [matTooltip]="getPasswordErrorTooltip()"
              [ngClass]="{ 'error-icon': hasPasswordError() }"
            >
              <mat-icon>remove_red_eye</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Confirmar Contraseña</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="none"
              formControlName="passwordConfirm"
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getPasswordConfirmErrorTooltip()"
              [ngClass]="{ 'error-icon': hasPasswordConfirmError() }"
              *ngIf="
                registerForm.get('passwordConfirm')!.hasError('required') ||
                (!registerForm.get('passwordConfirm')!.hasError('required') &&
                  registerForm
                    .get('passwordConfirm')!
                    .hasError('passwordsNotMatching'))
              "
              >error</mat-icon
            >
          </mat-form-field>
        </div>
        <div *ngIf="step === regiStep.securityPin">
          <div class="title">
            PIN DE SEGURIDAD
            <mat-icon
              matSuffix
              matTooltip="Crea un PIN en caso de olvidar tu contraseña"
              style="font-size: 16px; color: grey"
              onmouseover="this.style.color='darkcyan'"
              onmouseout="this.style.color='grey'"
              >info</mat-icon
            >
          </div>
          <div class="contentPin">
            <app-pin-code
              (pinCodeEmitter)="processPin($event)"
              [boardPinCode]="boardPinCode"
              [config]="pinCodeConfig"
            />
            <app-number-board
              (numberEmit)="receiveValue($event)"
            ></app-number-board>
          </div>
        </div>
        <div
          *ngIf="isRecuperarRegistro"
          class="register-recover"
          fxLayout="column"
          fxLayoutAlign="center center"
        >
          <a class="link" [routerLink]="'/auth/register/recover'"
            >Recuperar Registro</a
          >
        </div>
        <div
          *ngIf="isAlready"
          class="register-recover"
          fxLayout="column"
          fxLayoutAlign="center center"
        ></div>
        <div *ngIf="step === regiStep.securityPin">
          <div class="terms" fxLayout="row">
            <mat-checkbox
              formControlName="validado"
              name="terms"
              aria-label="Accept"
              required
            >
              <span>Aceptar</span>
            </mat-checkbox>
            <a href="#">Terminós y condiciones</a>
            <mat-icon
              matSuffix
              matTooltip="Debes aceptar terminos y condiciones para continuar"
              style="font-size: 16px; color: grey"
              onmouseover="this.style.color='darkcyan'"
              onmouseout="this.style.color='grey'"
              >info</mat-icon
            >
          </div>
          <div
            *ngIf="!registerForm.get('validado')!.hasError('required')"
            class="terms-ok"
          ></div>
          <button
            mat-raised-button
            color="accent"
            class="submit-button"
            aria-label="CREATE AN ACCOUNT"
            [disabled]="!registerForm.valid || isLoading"
          >
            <span *ngIf="!isLoading">REGISTRAR</span>
            <div class="loadingComponent" *ngIf="isLoading">
              <app-loading [isLoading]="isLoading" />
            </div>
          </button>
        </div>
      </form>
      <div *ngIf="step === regiStep.emailSent" class="registerConfirm">
        <h4>
          Te hemos enviado un enlace de registro al siguiente correo electronico
        </h4>
        <h4>{{ email }}</h4>
        <div *ngIf="!isEmailRegistered">
          <div class="sendMailContent">
            <a (click)="sendEmail()"
              >No has recibido enlace, volver a enviarlo</a
            >
            <div class="loadingMail">
              <app-loading
                [isLoading]="isSendingMail"
                class="loadingComponent"
              />
            </div>
          </div>
          <br />
          <br />
          <a (click)="cambiar()">Cambiar dirección de correo electronico</a>
          <br />
          <br />
        </div>
        <form
          name="cambiarForm"
          *ngIf="isShowCambiar && cambiarForm"
          [formGroup]="cambiarForm"
          (submit)="onSubmitCambiar()"
          novalidate
        >
          <mat-form-field appearance="outline">
            <mat-label>Nuevo email</mat-label>
            <input
              matInput
              autocomplete="email"
              formControlName="nuevoEmail"
              required
            />
            <mat-icon
              matSuffix
              class="secondary-text"
              [matTooltip]="getCambiarEmailErrorTooltip()"
              [ngClass]="{ 'error-icon': hasCambiarEmailError() }"
              >mail</mat-icon
            >
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            class="submit-button"
            aria-label="Cambiar"
            [disabled]="!cambiarForm.valid || isLoading"
          >
            <span *ngIf="!isLoading">CAMBIAR</span>
            <div class="loadingComponent" *ngIf="isLoading">
              <app-loading [isLoading]="isLoading" />
            </div>
          </button>
        </form>
      </div>
      <div class="buttonsSeccions">
        <button
          mat-raised-button
          color="warn"
          [ngClass]="{
            'w-button':
              !registerForm.get('cedula')!.hasError('prospectoExiste') ||
              (!registerForm.get('cedula')!.hasError('cedulaExiste') &&
                isClassButton),
            'w-button-max':
              (registerForm.get('cedula')!.hasError('prospectoExiste') ||
                registerForm.get('cedula')!.hasError('cedulaExiste')) &&
              !isClassButton,
          }"
          *ngIf="showPrevButton()"
          (click)="previous($event)"
        >
          Atrás
        </button>
        <button
          mat-raised-button
          color="primary"
          class="next w-button"
          *ngIf="enableNextButton()"
          (click)="next($event)"
        >
          Siguiente
        </button>
      </div>
    </div>
    <div class="copy">Nubyy 2019, Todos los derechos reservados.</div>
  </div>
</div>
